import { useEffect, useState } from "react";
import { api } from "./api";
import { CATEGORY } from "./labels";

let cache = null;

export const loadReference = (force = false) => {
  if (!cache || force) {
    cache = api.get("/public/reference").then(({ data }) => {
      data.categories.forEach((c) => { CATEGORY[c.code] = c.label; });
      return data;
    }).catch(() => { cache = null; return null; });
  }
  return cache;
};

export function useReference() {
  const [ref, setRef] = useState(null);
  useEffect(() => {
    let alive = true;
    loadReference().then((d) => { if (alive) { setRef(d); } });
    return () => { alive = false; };
  }, []);
  return ref;
}
